import React from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import "../style/services-usa/shopify-web-development/_provenTechniques.scss"

function ProvenTechniques() {
  return (
    <section className="redefinepatient_services tekgrip_section proven-techniques p-100 overflow-x-hidden">
      <Container>
        <Row>
          <Col xs={12} md={7} lg={7} xl={6} xxl={6}>
            <h2>
              Proven Techniques for Designing High-Performing Shopify Stores
            </h2>
          </Col>
          <Col xs={12} md={5} lg={5} xl={6} xxl={6}>
            <p>
              Building a successful Shopify website is more than just making it
              visually appealing. To deliver an enriched, seamless shopping
              experience, we draw from the current leading proficiency in
              eCommerce.
            </p>
          </Col>
        </Row>
        <Row className="mt-lg-5 mt-md-3 md-sm-2">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekgrip_tabs"
          >
            <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
              <Tab.Container id="" defaultActiveKey="0">
                <Row>
                  <Col xs={12} md={12} lg={12} xl={6} className="redefine_tabs">
                    <Nav variant="pills" className="flex-column">
                      <div className="red_item">
                        <Nav.Item>
                          <Nav.Link eventKey="0">
                            <span>01.</span> Intuitive Navigation
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="1"><span>02.</span> Visual Identity</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="2">
                            <span>03.</span> Benefits Driven- Messaging
                          </Nav.Link>
                        </Nav.Item>
                      </div>
                    </Nav>
                  </Col>
                  <Col xs={12} md={12} lg={12} xl={6} className="p-0">
                    <Tab.Content>
                      <Tab.Pane eventKey="0">
                        <div className="content-wrap">
                          <div className="content">
                            <h3>Intuitive Navigation</h3>
                            <p className="small-heading">Streamline User Journeys</p>
                            <p>
                              We ensure your Shopify site is easy to navigate,
                              with a clear menu layout and a streamlined
                              checkout process. We make it mobile-friendly and
                              offer personalized product recommendations to
                              enhance the shopping experience.
                            </p>
                          </div>
                          <div className="image">
                            <StaticImage
                              src="../../images/services-usa/shopify-web-development/intuitive-navigation.webp"
                              alt="Intuitive Navigation"
                              className="img-fluid mw-100"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={280}
                              height={364}
                            />
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="1">
                        <div className="content-wrap">
                          <div className="content">
                            <h3>Visual Identity</h3>
                            <p className="small-heading">
                              Invest in Custom Design and High-Quality Imagery
                            </p>
                            <p>
                              We know that custom design and quality images may
                              greatly improve the overall appearance of a
                              Shopify site. Polished, trendy lifestyle photos
                              make products appear more appealing and realistic.
                              We keep photos minimal to ensure a smooth browsing
                              experience without delays.
                            </p>
                          </div>
                          <div className="image">
                            <StaticImage
                              src="../../images/services-usa/shopify-web-development/visual-identity.webp"
                              alt="Intuitive Navigation"
                              className="img-fluid mw-100"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={280}
                              height={364}
                            />
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="2">
                        <div className="content-wrap">
                          <div className="content">
                            <h3>Benefits Driven- Messaging</h3>
                            <p className="small-heading">Focus on Client-Centric Language</p>
                            <p>
                              Our main goal should be to meet the needs and
                              desires of our target audience by focusing on
                              their pain points and how our offering can solve
                              them. This approach allows us to communicate in a
                              way that resonates with their goals, making the
                              content more compelling.
                            </p>
                          </div>
                          <div className="image">
                            <StaticImage
                              src="../../images/services-usa/shopify-web-development/benefits-driven-messaging.webp"
                              alt="Intuitive Navigation"
                              className="img-fluid mw-100"
                              layout="constrained"
                              placeholder="blurred"
                              formats={["auto"]}
                              width={280}
                              height={364}
                            />
                          </div>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ProvenTechniques;
